export default __webpack_public_path__ + "static/mock-sig-dbefce52b6473c76ec7f03ae91fad084.png";